module.exports = __webpack_public_path__ + "static/media/perfil.35c7f2c9.png";